import React, {createContext, useState, useMemo, useRef} from 'react';
import {View} from 'react-native';
import {createUseStyle} from '@redlink/assets/styles';
import {ToolTipContainer} from '@redlink/components/atoms';

export const TooltipContext = createContext({});

export const TooltipProvider = ({children}) => {
    const {styles} = useStyle();
    const [navigation, setNavigation] = useState();
    const renderContentRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);
    const [anchorLayout, setAnchorLayout] = useState({});

    const TooltipContextValue = useMemo(
        () => ({
            setNavigation: (nv) => {
                setNavigation(nv);
            },
            showTooltip: (layout, renderContent) => {
                setAnchorLayout(layout);
                renderContentRef.current = renderContent;
                setIsVisible(true);
            },
            dismissTooltip: () => {
                setIsVisible(false);
            }
        }),
        []
    );

    return (
        <TooltipContext.Provider value={TooltipContextValue}>
            <View style={styles.mainContainer}>
                {children}
                <ToolTipContainer
                    {...{isVisible, anchorLayout}}
                    onDismiss={() => setIsVisible(false)}
                >
                    {renderContentRef.current?.(navigation)}
                </ToolTipContainer>
            </View>
        </TooltipContext.Provider>
    );
};

const useStyle = createUseStyle(({colors, size, shadow}) => ({
    mainContainer: {
        flex: 1,
    },
}));
